import { Html } from "@custom/schema";
import React from "react";
export default function BlockTable(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "pb-5 md:pb-4 mb-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl overflow-hidden"
    }, props.tableHeading && /*#__PURE__*/ React.createElement("h2", {
        className: "font-medium text-xl md:text-3xl lg:text-4xl mb-5"
    }, props.tableHeading), /*#__PURE__*/ React.createElement("div", {
        className: "w-full overflow-x-auto"
    }, /*#__PURE__*/ React.createElement("table", {
        className: "w-full max-w-full border-collapse prose"
    }, /*#__PURE__*/ React.createElement("tbody", null, props.rows.map(function(row, rowIndex) {
        return /*#__PURE__*/ React.createElement("tr", {
            key: rowIndex,
            className: "border-b-2 border-b-gray-400"
        }, row.map(function(cell, cellIndex) {
            return /*#__PURE__*/ React.createElement("td", {
                key: cellIndex,
                className: "pl-4 first:pl-0 py-4 text-sm md:text-base align-middle"
            }, /*#__PURE__*/ React.createElement(Html, {
                markup: cell
            }));
        }));
    }))))));
}
